import { z } from 'zod';
import { EnvironmentEnum } from './backendBase';

// Frontend schema: only public variables (never include secrets)
const FrontendEnvSchema = z.object({
  ENVIRONMENT: EnvironmentEnum,
  DEN_API_URL: z.url(),
  PRODUCTION_URL: z.string().url(),
  UI_WEB_URL: z.string(),
});

type FrontendEnv = z.infer<typeof FrontendEnvSchema>;

// In browser bundles, bundlers replace individual process.env.KEY references at
// build time. Construct a minimal object for Zod instead of passing process.env.
export function getFrontendEnvVariables(): FrontendEnv {
  // Build a minimal object from individual injected keys; no defaults.
  const candidate = {
    ENVIRONMENT: process.env.ENVIRONMENT,
    PRODUCTION_URL: process.env.PRODUCTION_URL,
    DEN_API_URL: process.env.DEN_API_URL,
    UI_WEB_URL: process.env.UI_WEB_URL,
  };
  return FrontendEnvSchema.parse(candidate);
}
